<template>
  <div>
    <ColorPicker :other="() => this.editor.getAttributes('textStyle').color" :action="(color) => this.editor.chain().focus().setColor(color).run()" />
    <div ref="overflow-container" class="options-wrapper yellow-scroll">
      <template v-for="(item, index) in items">
        <div class="divider" v-if="item.type === 'divider'" :key="`divider${index}`" />
        <menu-item v-else :key="index" v-bind="item" />
      </template>
    </div>
    <div class="options" @click="toggleShowMenu" :class="showOptions ? 'visible': ''">
      ...
    </div>
    <div class="menu" :class="showMenu ? 'open': ''" ref="menu">
    </div>
  </div>
</template>

<script>
import MenuItem from './MenuItem.vue'
import ColorPicker from '@/components/shared/TextEditor/ColorPicker.vue'
import { nextTick } from 'vue'

export default {
  components: {
    ColorPicker,
    MenuItem
  },

  props: {
    editor: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      width: 0,
      showOptions: false,
      showMenu: false,
      itemWidth: 26.9,
      items: [
        {
          icon: 'bold',
          title: this.$t('shared.textEditor.bold'),
          action: () => this.editor.chain().focus().toggleBold().run(),
          isActive: () => this.editor.isActive('bold')

        },
        {
          icon: 'italic',
          title: 'Italic',
          action: () => this.editor.chain().focus().toggleItalic().run(),
          isActive: () => this.editor.isActive('italic')

        },
        {
          type: 'divider'
        },
        {
          icon: 'font-sans-serif',
          title: 'Sans-Serif',
          action: () => this.editor.chain().focus().setFontFamily('sans-serif').run(),
          isActive: () => this.editor.isActive('textStyle', { fontFamily: 'sans-serif' })

        },
        {
          icon: 'font-mono',
          title: 'Monospace',
          action: () => this.editor.chain().focus().setFontFamily('monospace').run(),
          isActive: () => this.editor.isActive('textStyle', { fontFamily: 'monospace' })

        },
        {
          icon: 'font-family',
          title: 'Cursive',
          action: () => this.editor.chain().focus().setFontFamily('cursive').run(),
          isActive: () => this.editor.isActive('textStyle', { fontFamily: 'cursive' })
        },
        {
          icon: 'arrow-up-circle-line',
          title: this.$t('shared.textEditor.increaseFontSize'),
          action: () => {
            let currentSize = this.editor.getAttributes('textStyle').fontSize
            if (currentSize) {
              currentSize = currentSize.split('px')[0]
              currentSize = currentSize < 40 ? currentSize = +currentSize + 4 : currentSize
            } else {
              currentSize = 20
            }
            this.editor.chain().focus().setFontSize(currentSize + 'px').run()
          },
          isActive: () => {}
        },
        {
          icon: 'arrow-down-circle-line',
          title: this.$t('shared.textEditor.decreaseFontSize'),
          action: () => {
            let currentSize = this.editor.getAttributes('textStyle').fontSize
            if (currentSize) {
              currentSize = currentSize.split('px')[0]
              currentSize = currentSize > 12 ? currentSize = +currentSize - 4 : currentSize
            } else {
              currentSize = 12
            }
            this.editor.chain().focus().setFontSize(currentSize + 'px').run()
          },
          isActive: () => {}
        },

        // {
        //   icon: 'arrow-up-circle-line',
        //   title: this.$t('shared.textEditor.increaseFontSize'),
        //   action: () => {
        //     let level = this.editor.getAttributes('heading').level
        //     console.log(level)
        //     if (level) {
        //       level = level > 2 ? level = +level - 1 : level
        //     } else {
        //       level = 3
        //     }
        //     this.editor.chain().focus().setHeading({ level: level }).run()
        //   },
        //   isActive: () => {}
        // },
        {
          type: 'divider'
        },
        {
          icon: 'list-unordered',
          title: this.$t('shared.textEditor.bulletList'),
          action: () => this.editor.chain().focus().toggleBulletList().run(),
          isActive: () => this.editor.isActive('bulletList')
        },
        {
          icon: 'list-ordered',
          title: this.$t('shared.textEditor.orderedList'),
          action: () => this.editor.chain().focus().toggleOrderedList().run(),
          isActive: () => this.editor.isActive('orderedList')

        },
        {
          icon: 'separator',
          title: this.$t('shared.textEditor.horizontalRule'),
          action: () => this.editor.chain().focus().setHorizontalRule().run()
        },

        {
          type: 'divider'
        },
        {
          icon: 'arrow-go-back-line',
          title: this.$t('shared.textEditor.undo'),
          action: () => this.editor.chain().focus().undo().run()
        },
        {
          icon: 'arrow-go-forward-line',
          title: this.$t('shared.textEditor.redo'),
          action: () => this.editor.chain().focus().redo().run()
        }
      ]
    }
  },
  mounted() {
    const container = this.$refs['overflow-container']
    this.width = container.offsetWidth + 1
    this.myEventHandler()
    window.addEventListener('resize', this.myEventHandler)
  },
  destroyed() {
    window.removeEventListener('resize', this.myEventHandler)
  },
  methods: {
    toggleShowMenu() {
      this.showMenu = !this.showMenu
    },
    async myEventHandler() {
      const container = this.$refs['overflow-container']
      const children = container.children
      const menu = this.$refs['menu']
      let currentWith = container.offsetWidth
      this.showOptions = currentWith < this.items.length * this.itemWidth
      await nextTick()
      currentWith = container.offsetWidth
      if (this.width > currentWith) {
        for (let i = 0; i < children.length; i) {
          if (this.itemWidth * children.length > currentWith) {
            menu.appendChild(children[children.length - 1])
          } else {
            break
          }
        }
      } else {
        for (let i = 0; i < menu.children.length; i) {
          if (this.itemWidth * children.length + this.itemWidth < currentWith) {
            container.appendChild(menu.children[menu.children.length - 1])
          } else {
            break
          }
        }
      }
      this.width = currentWith
    }
  }
}
</script>

<style scoped lang="scss">
.menu{
  display: none;
  &.open{
    display: flex;
    flex-direction: row-reverse;
    position: absolute;
    top: -40px;
    right: 0;
    background-color: rgb(248,248,248);
    border: 1px lightgrey solid;
    border-radius: 0.625rem;
  }
}
.options{
  display: none;
  &.visible{
    display: flex;
    padding: 0 8px 0 8px;
    max-width: 26.5px;
    border-radius: 0.325rem;
    height: 30px;
    justify-content: center;
    line-height: 19px;
    margin: auto 2px auto auto;

    &:hover {
      background-color: rgba(100,100,100, 0.1);
    }
  }
}
::v-deep .divider {
  background-color: rgba(#fff, 0.25);
  height: 1.25rem;
  margin-left: 12px;
  margin-right: 13px;
  width: 1px;
  display: inline-block;
}
.options-wrapper{
  width: calc(100% - 30px);
  overflow: hidden;
}
</style>
